import {
  type FormSchemaQuestionBaseType,
  type FormSchemaType,
} from "@validereinc/domain";
import React, { type ReactNode, useMemo } from "react";
import {
  FormCalculatedFieldService,
  type RenderableEquationTokenType,
} from "../../../logic/forms/index.ts";

export type CalculatedFieldEquationControllerProps = {
  children: (props: {
    displayEquation: string;
    plainTextEquation: string;
    tokens: RenderableEquationTokenType[];
  }) => ReactNode;
  equation: NonNullable<FormSchemaQuestionBaseType["equation"]>;
  sourceFieldValuesMap: Record<string, { value: number | null; unit?: string }>;
  questionsMap: FormSchemaType["config"]["questions"];
  getTokens?: boolean;
};

export const CalculatedFieldEquationController = ({
  equation,
  sourceFieldValuesMap,
  questionsMap,
  children,
  getTokens = false,
}: CalculatedFieldEquationControllerProps) => {
  const config = useMemo(() => {
    return FormCalculatedFieldService.getEquationDisplayConfig(
      equation,
      questionsMap,
      sourceFieldValuesMap,
      getTokens
    );
  }, [equation, questionsMap, sourceFieldValuesMap, getTokens]);

  const renderableTokens = useMemo((): RenderableEquationTokenType[] => {
    if (!config?.lexicalTokens) return [];

    return FormCalculatedFieldService.getRenderableEquationTokens(
      config.lexicalTokens,
      config.variablesToLabelsMap,
      sourceFieldValuesMap
    );
  }, [config, sourceFieldValuesMap]);

  return (
    <>
      {children({
        displayEquation: config?.displayEquation ?? equation,
        plainTextEquation: config?.plainTextEquation ?? equation,
        tokens: renderableTokens,
      })}
    </>
  );
};
